export const isHovered = ({ score, hover }: { score: number; hover: number | null }) => {
  return !!(hover && score <= hover);
};
